import React, { Component } from 'react';
import view, {
  propertyType,
  oyoFormView,
  borders,
  validation
} from '../../../Enums';
import { joinUsBtn } from '../../../partnerStyles';
import * as IMAGES from '../../../Images';
import DropdownMenu from '../../../common/DropdownMenu';
import BackIcon from '../../../resources/vectors/BackIcon';
import { guc } from '../../../services/Localisation';
import { logEvent, EVENT_CATEGORIES, EVENT_ACTIONS  } from '../../../services/Analytics';

class HomeStepTwoWidget extends Component {
  state = {
    hotel_address_border: borders.NORMAL_BORDER,
    showDropdown_struct_type: false,
    showDropdown_occupancy_status: false,
    showDropdown_are_you_a_owner: false,
    occupancyStatusList: {
      Vacant: 'Vacant',
      'Occupied By Self': 'Occupied By Self',
      'Occupied By Tenant': 'Occupied By Tenant'
    },
    areYouAnOwner: {
      Yes: 'Yes',
      No: 'No'
    },
    structTypeList: {
      Apartment: 'Apartment',
      'Independent House': 'Independent House',
      'Builder Floor': 'Builder Floor',
      Villa: 'Villa',
      Other: 'Other'
    }
  };
    
    componentDidMount() {
        const occupancyStatusList = {
            Vacant: guc('Vacant','Vacant'),
            'Occupied By Self': guc('occupied_by_self','Occupied By Self'),
            'Occupied By Tenant': guc('occupied_by_tenant','Occupied By Tenant')
        };
        const areYouAnOwner = {
            Yes: guc('Yes','Yes'),
            No: guc('No','No')
        };
        const structTypeList = {
            Apartment: guc('Apartment','Apartment'),
            'Independent House': guc('independent_house','Independent House'),
            'Builder Floor': guc('builder_floor','Builder Floor'),
            Villa: guc('Villa','Villa'),
            Other: guc('Other','Other')
        };
        this.setState({occupancyStatusList,areYouAnOwner,structTypeList});
    }
    
  render() {
    let gs = this.props.gs;
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gi = this.props.gi;

    return (
      <div>
        <div>
            <BackIcon className={'hover'} onClick={() => {
                this.props.changeFormScreen(oyoFormView.checkEarnings);
            }} style={gs('back')}/>
          <div style={gs('big_text_form')}>{guc('tell_us_more')}</div>

          <div style={gs('location_container')}>
            <div style={{...gs('form_small_text'),marginTop:'4px'}}>{guc('prop_address') + '*'}</div>
            <input
              placeholder={''}
              type="text"
              autoComplete="new-password"
              onChange={e => {
                this.props.globalActions.dataUpdate(
                  'hotel_address',
                  e.target.value
                );
                logEvent(EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME, EVENT_ACTIONS.ADDRESS_ENTERED, e.target.value);
                if (!this.props.hotel_address_border_validated) {
                  this.props.validateOneField(validation.HOME_ADDRESS);
                }
              }}
              value={this.props.globalData.formData.hotel_address}
              className={'removeFocusOutline'}
              style={{
                ...gs('input_form'),
                border: this.props.hotel_address_border_validated
                  ? this.state.hotel_address_border
                  : borders.RED_BORDER
              }}
              onFocus={() => {
                this.setState({
                  hotel_address_border: borders.ACTIVE_BORDER
                });
              }}
              onBlur={() => {
                this.setState({
                  hotel_address_border: borders.NORMAL_BORDER
                });
              }}
            />

            <div style={gs('form_small_text')}>{guc('struct_type') + '*'}</div>
            <div
              style={{
                ...gs('input_form'),
                position: 'relative',
                height: '42px',
                padding: '0',
                width: '100%',
                border: this.props.struct_type_validated
                  ? borders.NORMAL_BORDER
                  : borders.RED_BORDER
              }}
              onClick={() =>
                this.setState({
                  showDropdown_struct_type: !this.state.showDropdown_struct_type
                })
              }
            >
              <img
                src={IMAGES.DOWN_ARROW}
                className={'hover'}
                style={gs('img_form_down_dropdown')}
              />
              <span style={gs('dropdown_child')}>
                {this.props.globalData.formData.structure_type_home}
              </span>

              {this.state.showDropdown_struct_type && (
                <DropdownMenu
                  showScrollBar
                  extraStyle={{
                    height: '100px',
                    width: '100%',
                    top: '100%'
                  }}
                  s={Object.values(this.state.structTypeList)}
                  category={EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME}
                  action2={EVENT_ACTIONS.STRUCTURE_TYPE_ENTERED}
                  k={(type, value) => {
                    this.setState({ showDropdown_struct_type: false });
                    this.props.globalActions.dataUpdate(
                      'structure_type_home',
                      value
                    );
                    this.props.validateOneField(validation.HOME_STRUCTURE_TYPE);
                  }}
                  t={this.state.showDropdown_struct_type}
                  name="structure_type"
                />
              )}
            </div>

            <div style={gs('form_small_text')}>{guc('occupancy_status')}</div>

            <div
              style={{
                ...gs('input_form'),
                position: 'relative',
                height: '42px',
                padding: '0',
                width: '100%',
                border: this.state.showDropdown_occupancy_status
                  ? borders.ACTIVE_BORDER
                  : borders.NORMAL_BORDER
              }}
              onClick={() =>
                this.setState({
                  showDropdown_occupancy_status: !this.state
                    .showDropdown_occupancy_status
                })
              }
            >
              <img
                src={IMAGES.DOWN_ARROW}
                className={'hover'}
                style={gs('img_form_down_dropdown')}
              />
              <span style={gs('dropdown_child')}>
                {this.props.globalData.formData.occupancy_status}
              </span>

              {this.state.showDropdown_occupancy_status && (
                <DropdownMenu
                  showScrollBar
                  extraStyle={{
                    height: '100px',
                    width: '100%',
                    top: '100%'
                  }}
                  s={Object.values(this.state.occupancyStatusList)}
                  category={EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME}
                  action2={EVENT_ACTIONS.OCCUPANY_STATUS_ENTERED}
                  k={(type, value) => {
                    this.setState({ showDropdown_occupancy_status: false });
                    this.props.globalActions.dataUpdate(
                      'occupancy_status',
                      value
                    );
                  }}
                  t={this.state.occupancyStatusList}
                  name="occupancy_status"
                />
              )}
            </div>

            <div style={gs('form_small_text')}>{guc('are_u_an_owner')}</div>

            <div
              style={{
                ...gs('input_form'),
                position: 'relative',
                height: '42px',
                padding: '0',
                width: '100%',
                border: this.state.showDropdown_are_you_a_owner
                  ? borders.ACTIVE_BORDER
                  : borders.NORMAL_BORDER
              }}
              onClick={() =>
                this.setState({
                  showDropdown_are_you_a_owner: !this.state
                    .showDropdown_are_you_a_owner
                })
              }
            >
              <img
                src={IMAGES.DOWN_ARROW}
                className={'hover'}
                style={gs('img_form_down_dropdown')}
              />
              <span style={gs('dropdown_child')}>
                {this.props.globalData.formData.are_you_a_owner}
              </span>

              {this.state.showDropdown_are_you_a_owner && (
                <DropdownMenu
                  category={EVENT_CATEGORIES.PARTNER_PAGE_LANDING_FORM_HOME}
                  action2={EVENT_ACTIONS.ARE_YOU_A_OWNER_SELECTED}
                  showScrollBar={false}
                  extraStyle={{
                    height: '100px',
                    width: '100%',
                    top: '100%'
                  }}
                  s={Object.values(this.state.areYouAnOwner)}
                  k={(type, value) => {
                    this.setState({ showDropdown_are_you_a_owner: false });
                    this.props.globalActions.dataUpdate(
                      'are_you_a_owner',
                      value
                    );
                  }}
                  t={this.state.areYouAnOwner}
                  name="are_you_a_owner"
                />
              )}
            </div>

            {/*<div style={gs('form_small_text')}>{guc('prop_name')}</div>*/}
            {/*<input*/}
            {/*  placeholder={''}*/}
            {/*  type="text"*/}
            {/*  autoComplete="new-password"*/}
            {/*  onChange={e => {*/}
            {/*    if (e.target.value.length > 0) {*/}
            {/*      this.setState({ hotel_name_border: true });*/}
            {/*    }*/}
            {/*    this.props.globalActions.dataUpdate(*/}
            {/*      'hotel_name',*/}
            {/*      e.target.value*/}
            {/*    );*/}
            {/*  }}*/}
            {/*  value={this.props.globalData.formData.hotel_name}*/}
            {/*  className={'removeFocusOutline'}*/}
            {/*  style={{*/}
            {/*    ...gs('input_form'),*/}
            {/*    border: this.props.hotel_name_border_validated*/}
            {/*      ? this.state.hotel_name_border*/}
            {/*      : borders.RED_BORDER*/}
            {/*  }}*/}
            {/*  onFocus={() => {*/}
            {/*    this.setState({*/}
            {/*      hotel_name_border: borders.ACTIVE_BORDER*/}
            {/*    });*/}
            {/*  }}*/}
            {/*  onBlur={() => {*/}
            {/*    this.setState({*/}
            {/*      hotel_name_border: borders.NORMAL_BORDER*/}
            {/*    });*/}
            {/*  }}*/}
            {/*/>*/}

            {/*<div style={gs('form_small_text')}>{guc('your_email')}</div>*/}
            {/*<input*/}
            {/*  placeholder={''}*/}
            {/*  type="text"*/}
            {/*  autoComplete="new-password"*/}
            {/*  onChange={e => {*/}
            {/*    if (e.target.value.length > 0) {*/}
            {/*      this.setState({ email_border: true });*/}
            {/*    }*/}
            {/*    this.props.globalActions.dataUpdate(*/}
            {/*      'email_address',*/}
            {/*      e.target.value*/}
            {/*    );*/}
            {/*  }}*/}
            {/*  value={this.props.globalData.formData.email_address}*/}
            {/*  className={'removeFocusOutline'}*/}
            {/*  style={{*/}
            {/*    ...gs('input_form'),*/}
            {/*    border: this.props.email_border_validated*/}
            {/*      ? this.state.email_border*/}
            {/*      : borders.RED_BORDER*/}
            {/*  }}*/}
            {/*  onFocus={() => {*/}
            {/*    this.setState({*/}
            {/*      email_border: borders.ACTIVE_BORDER*/}
            {/*    });*/}
            {/*  }}*/}
            {/*  onBlur={() => {*/}
            {/*    this.setState({*/}
            {/*      email_border: borders.NORMAL_BORDER*/}
            {/*    });*/}
            {/*  }}*/}
            {/*/>*/}
          </div>
        </div>
      </div>
    );
  }
}

export default HomeStepTwoWidget;
